module.exports = __webpack_public_path__ + "img/maintop.45b56ca.png";